import { Box } from '@cloudscape-design/components';
import type { changeText } from './usageApi';

const COLORS = { up: 'text-status-success', down: 'text-status-error', flat: 'text-body-secondary', new: 'text-body-secondary' } as const;

/**
 * "▲ 73%" and friends, colored by direction. With `soFar` (a period still in progress, compared
 * with a whole one) a percentage reads "▲ 73% so far" in a neutral color, so a partial period
 * never looks like a drop.
 */
export function ChangeText({ change, soFar = false }: { change: ReturnType<typeof changeText>; soFar?: boolean }) {
  const partial = soFar && (change.direction === 'up' || change.direction === 'down');
  return (
    <Box variant="small" color={soFar ? 'text-body-secondary' : COLORS[change.direction]}>
      {partial ? `${change.text} so far` : change.text}
    </Box>
  );
}
